<template>
	<div class="item">
		<a class="link" @click="toggle">
			<div class="placeholder">
				<img v-if="img" :src="thumb"/>
				<video v-else-if="video" :src="media.url"/>
				<div v-else class="icon" v-html="documentIcon"/>
			</div>
			<div class="title" v-text="name"/>
		</a>

		<itemModal v-if="active" v-bind="{id, img, video, name, media, updated_at, download_url}" @close="toggle"/>
	</div>
</template>

<script>
import itemModal from "./item-modal.vue";

export default {
	components: {itemModal},
	props: {
		id: {type: Number, required: true},
		name: {type: String, required: true},
		media: {type: Object, required: true},
		thumb: {type: String, required: false},
		updated_at: {type: Number, required: true},
		download_url: {type: String, required: true}
	},
	data() {
		return {
			active: false
		}
	},
	computed: {
		img() {
			const m = this.media.mime_type;
			return m.endsWith("jpeg") || m.endsWith("jpg") || m.endsWith("png") || m.endsWith("gif");
		},
		video() {
			const m = this.media.mime_type;
			return m.endsWith("mp4");
		},
		documentIcon() {
			const m = this.media.mime_type;
			return m.endsWith("pdf") ? require('@/assets/icons/file-pdf-regular.svg') : require('@/assets/icons/file-archive-regular.svg');
		}
	},
	methods: {
		toggle() {
			this.active = !this.active;
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	width: 110px;
	margin: 20px 32px;

	@include res(tablet) {
		margin: 22px;
	}

	@include res(mobile) {
		width: 100%;
		margin: 0;
		padding: 20px 0;
		border-bottom: 1px solid #E2E2E2;
		&:first-child {
			border-top: 1px solid #E2E2E2;
		}
	}

	.link {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		transition: opacity .15s ease-in-out;

		&:hover {
			opacity: 0.6;
		}

		@include res(mobile) {
			flex-direction: row;
			justify-content: flex-start;
		}

		.placeholder {
			width: 110px;
			height: 140px;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 14px;
			max-width: 100%;
			flex-shrink: 0;

			@include res(mobile) {
				height: auto;
				max-height: 50px;
				margin-bottom: 0;
				width: auto;
				max-width: 40px;
				margin-right: 20px;
			}

			img {
				display: block;
				max-height: 100%;
				max-width: 100%;
				width: 100%;
			}

			video {
				display: block;
				max-height: 100%;
				max-width: 100%;
				width: 100%;
			}

			.icon {
				/deep/ svg {
					width: 6em;
					height: 6em;
					max-width: 100%;
					max-height: 100%;
					path {
						fill: #22313A;
					}
				}
			}
		}

		.title {
			font-size: 11px;
			font-weight: 300;
			word-break: break-all;
			max-width: 100%;
		}
	}
}
</style>
